module.exports = __webpack_public_path__ + "img/logo.b71c04e6.svg";